import { cn } from 'cn';
import { type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

type P = {
  readonly classNameLabel?: string;
  readonly classNameValue?: string;
  readonly label: string;
  readonly value: ReactNode;
};

export const SimpleLabelValue = ({
  classNameLabel,
  classNameValue,
  label,
  value,
}: P) => {
  const { t } = useTranslation('common');

  return (
    <>
      <span className={cn('text-tiga-text-lighter', classNameLabel)}>
        {label}
      </span>
      <span className={cn(classNameValue)}>
        {typeof value === 'boolean'
          ? value
            ? t(($) => $.yes)
            : t(($) => $.no)
          : value}
      </span>
    </>
  );
};
